import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import ReportManagement from '../../../components/siteadmin/ReportManagement';
import Loader from '../../../components/Loader';

import reportUserQuery from './reportUserQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './ReportUser.css';
class ReportUser extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getAllReport: PropTypes.array,
        })
    };

    render() {
        const { reportUserManagement: { loading, reportUserManagement } } = this.props;

        return loading ? <Loader type={"text"} /> : <ReportManagement reportUserManagement={reportUserManagement} />;
    }
}

export default compose(
    withStyles(s),
    withQuery(reportUserQuery, {
        name: 'reportUserManagement',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(ReportUser);
